import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IdentityState {
 accessToken?: string | null;
 refreshToken?: string | null;
 expiration?: number | null;
 loading?: { [key: string]: boolean | null };
 success?: { [key: string]: boolean | null };
}

export const initialState: IdentityState = {
 accessToken: null,
 refreshToken: null,
 expiration: null,
 loading: {},
 success: {},
};

const identitySlice = createSlice({
 name: 'identity',
 initialState,
 reducers: {
  identityLoginStart(
   state,
   action: PayloadAction<{ email: string; password: string }>,
  ) {
   return {
    ...state,
    loading: { ...state.loading, identityLogin: true },
   };
  },
  identityLoginSuccess(state, action: PayloadAction<IdentityState>) {
   return {
    ...state,
    accessToken: action.payload.accessToken,
    refreshToken: action.payload.refreshToken,
    expiration: action.payload.expiration,
    success: { ...state.success, identityLogin: true },
    loading: { ...state.loading, identityLogin: null },
   };
  },
  identityLoginFailure(state) {
   return {
    ...state,
    success: { ...state.success, identityLogin: null },
    loading: { ...state.loading, identityLogin: null },
   };
  },
  identityLogoutStart(state) {
   return {
    ...state,
    loading: { ...state.loading, identityLogout: true },
   };
  },
  identityLogoutSuccess(state, action: PayloadAction<IdentityState>) {
   return {
    ...state,
    success: { ...state.success, identityLogout: true },
    loading: { ...state.loading, identityLogout: null },
   };
  },
  identityLogoutFailure(state) {
   return {
    ...state,
    success: { ...state.success, identityLogout: null },
    loading: { ...state.loading, identityLogout: null },
   };
  },
 },
});
export const {
 identityLoginStart,
 identityLoginSuccess,
 identityLoginFailure,
 identityLogoutStart,
 identityLogoutSuccess,
 identityLogoutFailure,
} = identitySlice.actions;
export default identitySlice.reducer;
